import { useContext, useState, useEffect } from "react";
import SondageQuestionsServices from "../services/sondageQuestionsServices";
import { AuthContext } from "../contexts/AuthContext";

const useSondageQuestion = () => {
  const { api } = useContext(AuthContext);
  const service = new SondageQuestionsServices(api);

  const getAllSondageQuestions = () => {
    return service.getAll();
  };

  const getOneSondageQuestion = (id) => {
    return service.getOne(id);
  };

  const createSondageQuestion = (question) => {
    return service.create(question);
  };

  const updateSondageQuestion = (id, question) => {
    return service.update(id, question);
  };

  const deleteSondageQuestion = (id) => {
    return service.delete(id);
  };

  return {
    getAllSondageQuestions,
    getOneSondageQuestion,
    createSondageQuestion,
    updateSondageQuestion,
    deleteSondageQuestion,
  };
}

export default useSondageQuestion;
